const ARCHETYPES_SYMBOLS = {
  contributor: "IC",
  tech_lead: "TL",
  squad_lead: "SL",
};

export default ARCHETYPES_SYMBOLS;
